'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX, ReactNode } from 'react';
import { onEvent } from '@/events';
import { NetworkLink } from '@/i18n/network-link';
import { cn } from '@/lib/ui/utils';
import { MorfiProductButtonChrome } from './morfi-product-button';
export type LandingProductCtaSurface = 'hero' | 'header' | 'mobile' | 'lower';
const PRODUCT_HREF = '/markets' as const;
interface LandingProductLinkProps {
  children: ReactNode;
  className?: string;
  markerHeroCta?: boolean;
  surface: LandingProductCtaSurface;
}
export function LandingProductLink(t0) {
  const $ = _c(9);
  const {
    children,
    className,
    markerHeroCta: t1,
    surface
  } = t0;
  const markerHeroCta = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== surface) {
    t2 = () => {
      onEvent("landing_product_cta_clicked", {
        destination: PRODUCT_HREF,
        surface
      });
    };
    $[0] = surface;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== markerHeroCta) {
    t3 = markerHeroCta ? {
      "data-morfi-hero-product-cta": ""
    } : {};
    $[2] = markerHeroCta;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== className || $[6] !== t2 || $[7] !== t3) {
    t4 = <NetworkLink href={PRODUCT_HREF} className={className} onClick={t2} {...t3}>{children}</NetworkLink>;
    $[4] = children;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export function MorfiProductButton(t0) {
  const $ = _c(9);
  const {
    children,
    className,
    markerHeroCta: t1,
    surface
  } = t0;
  const markerHeroCta = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("morfi-product-button", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <MorfiProductButtonChrome>{children}</MorfiProductButtonChrome>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== markerHeroCta || $[5] !== surface || $[6] !== t2 || $[7] !== t3) {
    t4 = <LandingProductLink className={t2} markerHeroCta={markerHeroCta} surface={surface}>{t3}</LandingProductLink>;
    $[4] = markerHeroCta;
    $[5] = surface;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}